
import Vue from 'vue'
import Logo from '~/components/images/SatelliteLogo.vue'
import MenuListLarge from '~/components/navigations/satellite/MenuListLarge.vue'

export default Vue.extend({
  name: 'TopNavigation',
  components: { Logo, MenuListLarge },
})
